import { render, staticRenderFns } from "./relist.vue?vue&type=template&id=74bcca23&scoped=true"
import script from "./relist.vue?vue&type=script&lang=js"
export * from "./relist.vue?vue&type=script&lang=js"
import style0 from "./relist.vue?vue&type=style&index=0&id=74bcca23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bcca23",
  null
  
)

export default component.exports